import React from 'react'

const NotFound = () => {
  return (
    <>
      <main>
        <h1>Doggonit!</h1>
        <h2>These are not the dogs you are looking for.</h2>
        <h3>The page does not exist.</h3>
      </main>
    </>
  )
}

export default NotFound
